import "./index.scss";
import React, { useEffect, useState } from "react";
import Spinner from "../../../../components/Spinner";
import { IconTrash, IconPencil } from "../../../../icons";
import IconButton from "../../../../components/IconButton";
import { ModalPopUp } from "../../../../components/ModalPopUp";
import FormJobPosition from "./subModule/form";
import useAppData from "../../../../hook/useAppData";
import { delCostCenter, getCostCenter } from "../../service";
import { ModalMessage } from "../../../../components/ModalMessage";
import { orderByName } from "../../../../libs/orderList";

function ListCostCenters() {
  const { token } = useAppData();
  const [updateValue, setUpdateValue] = useState([]);
  const [getId, setGetId] = useState(undefined);
  const [needSpinner, setNeedSpinner] = useState(false);
  const [emptyFilter, setEmptyFilter] = useState(false);
  const [modalStatus, setModalStatus] = useState(false);
  const [needModalDelete, setNeedModalDelete] = useState({
    status: false,
    id: 0,
  });

  useEffect(() => {
    setNeedSpinner(true);
    getCostCenters();
  }, []);

  useEffect(() => {
    setNeedSpinner(true);
    setTimeout(() => setNeedSpinner(false), 500);
  }, [updateValue]);

  function getCostCenters() {
    setNeedSpinner(true);
    getCostCenter(token)?.then((data: any) => {
      const dataByOrder = orderByName(data, "name");
      setUpdateValue(dataByOrder);
      setNeedSpinner(false);
      setTimeout(() => setNeedSpinner(false), 5000);
    });
  }

  function exitPopUp() {
    return setModalStatus(false);
  }

  function handleDeleteClick(id: number) {
    setNeedSpinner(true);
    delCostCenter(id, token).then(() => {
      getCostCenters();
      setTimeout(() => {
        setNeedSpinner(false);
      }, 100);
    });
  }

  return (
    <div className="jobPositionContainer container">
      <Spinner status={needSpinner}>
        <ModalMessage
          status={needModalDelete.status}
          id={needModalDelete.id}
          onClickCancel={setNeedModalDelete}
          onClickConfirm={handleDeleteClick}
          text="Confirma a exclusão?"
        />
        <ModalPopUp status={modalStatus} onClickCancel={exitPopUp}>
          <FormJobPosition id={getId} List={updateValue} getCostCenter={getCostCenters} setModalStatus={setModalStatus} />
        </ModalPopUp>

        <div className="box-title">
          <h1 className="title-form">Centro de Custo</h1>
          <button
            type="button"
            className="btn bg-primary"
            onClick={() => {
              setModalStatus(true);
              setGetId(undefined);
            }}
          >
            Novo Centro de Custo
          </button>
        </div>
        <div className="jobPositionTableContainer table-container-full box-shadow">
          <table className="table-container-header-body ">
            {emptyFilter === true ? (
              <div className="nothing-list">
                <h1>Não há registros para a busca realizada.</h1>
              </div>
            ) : (
              <>
                <thead>
                  <tr>
                    <th className="header-left ">Centro de Custo</th>
                    <th className="col-function header-center">Editar</th>
                    {/* <th className="col-function header-center">Deletar</th> */}
                  </tr>
                </thead>
                <tbody>
                  {updateValue?.map((data: any, index: any, array: any) => {
                    const { name, id } = data;
                    return (
                      <tr className={`"collaboratorTableRow" ${index % 2 !== 0 && "rowGrey"}`}>
                        <td className="td-name">{name}</td>
                        <td className="col-function">
                          <IconButton
                            className="row-trash icon-pencil"
                            icon={IconPencil}
                            onClick={() => {
                              setModalStatus(true);
                              setGetId(id);
                            }}
                          />
                        </td>
                        {/* <td className="col-function">
                          <IconButton
                            className="row-trash icon-trash"
                            icon={IconTrash}
                            onClick={() => setNeedModalDelete({ status: true, id: id })}
                          />
                        </td> */}
                      </tr>
                    );
                  })}
                </tbody>
              </>
            )}
          </table>
        </div>
      </Spinner>
    </div>
  );
}

export default ListCostCenters;
